// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"1b097a7c","117":"caff5f69","166":"3ddbd3ea","207":"b18f71b0","216":"8d30aaa3","452":"66d84175","563":"cba7a44d","671":"34e8a2e0","683":"3d5758f3","711":"5ae0c58f","787":"44f5ae0a","841":"1972b86e","869":"f2584219","954":"a3195c7e"}[chunkId] + ".chunk.js";
};